import { render, staticRenderFns } from "./SelectWalletModal.vue?vue&type=template&id=6e751e0d&"
import script from "./SelectWalletModal.vue?vue&type=script&lang=js&"
export * from "./SelectWalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports